import React, { Component } from 'react';
import UniversalNavigator from '../UniversalNavigator.js';
import GuildsContentView from './GuildsContentView.js';
import '../../Guilds.scss';
import PasswordModal from 'components/modals/PasswordModal.js';
import ethereum from 'decentralized/ethereum.js';
import accounts from 'accounts/Accounts.js';

class GuildsPage extends Component {
    constructor(props) {
        super(props);

        accounts.setStore(this.props.store);
        ethereum.store = this.props.store;
        accounts.setEthereum(ethereum);
        accounts.checkLogin();
        ethereum.guilds.initGuilds();
        ethereum.crypto.store = this.props.store;
    }
    render() {
        return (
            <div className="guilds-page">
              <PasswordModal crypto={ethereum.crypto} show={true}/>
              <UniversalNavigator store={this.props.store}/>
              <GuildsContentView store={this.props.store}/>
            </div>
        );
    }
}

export default GuildsPage;
